module.exports = __webpack_public_path__ + "static/img/image-bass-pack@2x.7b4eef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/expansion/image-bass-pack@2x.png
// module id = oEgj
// module chunks = 13